<template>
  <div class="add-user">
    <div class="user-row mb20 mt20">
      <label class="field">
        <div class="field__label">
          {{ texts.enter_wallet_address }}
        </div>
        <input
          v-model="walletAddress"
          type="text"
          class="field__field"
          :placeholder="texts.wallet_address_placeholder"
        />
        <p v-if="addressValidationError" class="field__error-message">
          {{ addressValidationError }}
        </p>
      </label>
      <label class="field">
        <div class="field__label">
          {{ texts.enter_name }}
        </div>
        <input
          v-model="username"
          type="text"
          class="field__field"
          :placeholder="texts.enter_name_placeholder"
        />
      </label>
    </div>

    <div class="field__label mb10">
      {{ texts?.pick_a_role }}
    </div>
    <label class="role-row" @click="userRole = ACCESS_LEVELS.READ_WRITE">
      <DeployerUiFormRadioButton
        :is-checked="ACCESS_LEVELS.READ_WRITE === userRole"
      />
      <span v-html="texts?.roles?.[0]?.label" />
    </label>
    <label class="role-row" @click="userRole = ACCESS_LEVELS.READ">
      <DeployerUiFormRadioButton
        :is-checked="ACCESS_LEVELS.READ === userRole"
      />
      <span v-html="texts.roles?.[1]?.label" />
    </label>

    <button
      class="btn grey-border mt20"
      @click.prevent="sendInvite"
      v-html="texts?.send_invite"
    />
  </div>
</template>

<script setup>
import { ACCESS_LEVELS } from '../../../stores/account.js'
import { isAddress } from 'viem'

const textsStore = useTextsStore()
const texts = computed(() => textsStore.account.team)

const walletAddress = ref('')
const username = ref('')
const userRole = ref(ACCESS_LEVELS.READ)
const addressValidationError = ref('')

const accountStore = useAccountStore()

const sendInvite = async () => {
  addressValidationError.value = ''

  if (isAddress(walletAddress.value)) {
    await accountStore.addWalletToAccount(walletAddress.value, username.value)
  } else {
    addressValidationError.value = 'Invalid address'
  }
}
</script>

<style lang="scss" scoped>
.field {
  display: block;
  width: 100%;

  &__label {
    font-size: 1.4rem;
    opacity: 0.5;
    margin-bottom: 5px;
  }

  &__field {
    width: 100%;
    height: 50px;
    border-radius: 10px;
    background: var(--Banner-5, rgba(0, 0, 0, 0.05));
    font-weight: 500;
    border: 0;
    padding-inline: 20px;
    color: var(--Text, #000);
    font-size: 1.5rem;
  }

  &__error-message {
    color: #e71313;
  }
}

.user-row {
  @media (max-width: 639px) {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  @media (min-width: 640px) {
    display: grid;
    gap: 20px;
    grid-template-columns: 58% auto;
  }
}

.role-row {
  display: flex;
  gap: 10px;
  margin-top: 15px;

  span {
    flex: 1 1 0;
  }
}
</style>
